(() => {
  if (!document.documentElement.hasAttribute('data-voicsky-reiko-product')) return;
  const header = document.querySelector('#header-component');
  const group = document.querySelector('#header-group');
  const columns = header?.querySelector('.header__row--top .header__columns');
  if (!header || !group || !columns) return;
  const pictures = new WeakMap();
  let frame = 0;
  const luminance = (rgb) => rgb.map((channel) => {
    const value = channel / 255;
    return value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4;
  }).reduce((total, value, index) => total + value * [.2126, .7152, .0722][index], 0);
  const sampleImage = (image, x, y) => {
    if (!image.complete || !image.naturalWidth) return null;
    let cached = pictures.get(image);
    if (!cached || cached.source !== image.currentSrc) {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 64;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0, 64, 64);
        cached = { source: image.currentSrc, pixels: context.getImageData(0, 0, 64, 64).data };
      } catch {
        cached = { source: image.currentSrc, pixels: null };
      }
      pictures.set(image, cached);
    }
    if (!cached.pixels) return null;
    const bounds = image.getBoundingClientRect();
    const fit = getComputedStyle(image).objectFit;
    const scale = fit === 'contain'
      ? Math.min(bounds.width / image.naturalWidth, bounds.height / image.naturalHeight)
      : Math.max(bounds.width / image.naturalWidth, bounds.height / image.naturalHeight);
    const width = image.naturalWidth * scale;
    const height = image.naturalHeight * scale;
    const u = (x - bounds.left + (width - bounds.width) / 2) / width;
    const v = (y - bounds.top + (height - bounds.height) / 2) / height;
    if (u < 0 || u > 1 || v < 0 || v > 1) return null;
    const offset = (Math.min(63, Math.floor(v * 64)) * 64 + Math.min(63, Math.floor(u * 64))) * 4;
    if (cached.pixels[offset + 3] < 240) return null;
    return [...cached.pixels.slice(offset, offset + 3)];
  };
  const backgroundAt = (x, y) => {
    const elements = document.elementsFromPoint(x, y).filter((node) => !group.contains(node));
    const surface = elements.find((node) => node !== document.body && node !== document.documentElement);
    if (!surface) return [245, 245, 247];
    const hero = surface.closest('.voicsky-product-experience__hero');
    if (hero) {
      for (const image of hero.querySelectorAll('img')) {
        const bounds = image.getBoundingClientRect();
        if (!bounds.width || x < bounds.left || x > bounds.right || y < bounds.top || y > bounds.bottom) continue;
        const sample = sampleImage(image, x, y);
        if (sample) return sample;
      }
      return [17, 17, 19];
    }
    let node = surface;
    let result = [0, 0, 0];
    let alpha = 0;
    while (node && alpha < .99) {
      const rgba = getComputedStyle(node).backgroundColor.match(/[\d.]+/g)?.map(Number);
      if (rgba?.length >= 3) {
        const opacity = rgba[3] ?? 1;
        result = result.map((value, index) => value + rgba[index] * opacity * (1 - alpha));
        alpha += opacity * (1 - alpha);
      }
      node = node.parentElement;
    }
    return result.map((value) => value + 245 * (1 - alpha));
  };
  const update = () => {
    frame = 0;
    const bounds = columns.getBoundingClientRect();
    if (!bounds.width || bounds.bottom <= 0) return;
    const drawer = window.matchMedia('(max-width: 1199px)').matches || header.dataset.menuStyle === 'drawer';
    header.dataset.reikoHeaderDrawer = String(drawer);
    const open = (!drawer && header.matches(':hover, :focus-within')) || header.dataset.stickyState === 'active'
      || !!header.querySelector('details[open]')
      || [...group.querySelectorAll('.voicsky-mega-panel')].some((panel) => panel.matches(':hover, :focus-within'));
    let tone = 'light';
    if (!open && document.querySelector('voicsky-product-experience')?.dataset.view === 'hero') {
      tone = 'dark';
    } else if (!open) {
      const y = Math.max(0, bounds.top + bounds.height / 2);
      const samples = [.3, .5, .7].map((fraction) => luminance(backgroundAt(bounds.left + bounds.width * fraction, y))).sort((a, b) => a - b);
      const lightness = samples[1];
      const darkInk = luminance([21, 21, 21]);
      if (1.05 / (lightness + .05) > (lightness + .05) / (darkInk + .05)) tone = 'dark';
    }
    if (header.dataset.reikoHeaderSurface !== tone) header.dataset.reikoHeaderSurface = tone;
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  ['pointerover', 'pointerout', 'focusin', 'focusout', 'toggle'].forEach((type) => group.addEventListener(type, schedule, true));
  document.addEventListener('load', schedule, true);
  document.addEventListener('loadeddata', schedule, true);
  const observer = new MutationObserver(schedule);
  observer.observe(header, { attributes: true, attributeFilter: ['data-sticky-state', 'data-menu-style', 'open'] });
  const experience = document.querySelector('voicsky-product-experience');
  if (experience) observer.observe(experience, { attributes: true, attributeFilter: ['data-view'] });
  schedule();
})();
